import React, { createContext, useState, useContext, ReactNode, useEffect } from 'react';
import { useSubstrateApi, SUBSTRATE_ENDPOINTS } from './substrate';
import { ApiContextType } from '../types';

const ApiContext = createContext<ApiContextType | undefined>(undefined);

export const ApiProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  // Initialize with stored endpoint or default to production
  const [endpoint, setEndpointState] = useState<string>(() => {
    try {
      const storedEndpoint = localStorage.getItem('tfchain-explorer-endpoint');
      return storedEndpoint || SUBSTRATE_ENDPOINTS.tfchain_prod;
    } catch (e) {
      // In case localStorage is not available (e.g. in some iframe contexts)
      return SUBSTRATE_ENDPOINTS.tfchain_prod;
    }
  });

  // Custom setEndpoint function that also updates localStorage
  const setEndpoint = (newEndpoint: string) => {
    try {
      localStorage.setItem('tfchain-explorer-endpoint', newEndpoint);
    } catch (e) {
      console.warn('Failed to save endpoint to localStorage:', e);
    }
    setEndpointState(newEndpoint);
  };

  const { api, isConnected, error } = useSubstrateApi(endpoint);

  return (
    <ApiContext.Provider value={{ api, isConnected, error, endpoint, setEndpoint }}>
      {children}
    </ApiContext.Provider>
  );
};

export const useApi = (): ApiContextType => {
  const context = useContext(ApiContext);
  if (context === undefined) {
    throw new Error('useApi must be used within an ApiProvider');
  }
  return context;
};
